export { useBrowsePrimitivesCompoundsPageNavigator } from "#use-browse-primitives-compounds-page-navigator";
